import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-walkthrough-empty-component',
  standalone: true,

  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class WalkthroughEmptyComponent {}
